/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-13 16:17:47
 * @LastEditors: caiqin.xie
 * @message: 权益查询-Notes组件
 */
import React from "react";
import { Link } from "react-router-dom";
import styles from "../../index.module.scss";
import { transDocToHtml } from '@/common/splitLine'

interface IProps {
  ctry: string;
  words: Record<string, string>;
}

const Notes = (props:IProps) => {
  const {ctry, words} = props
  return (
    <div className={styles["remind-wrap"]}>
      <h2>
        {words?.support_benefit_notes}
        {/* Notes */}
      </h2>
      <p>
        {transDocToHtml(words?.support_benefit_notes_content1)} 
        {/* <a href={`/${ctry}/support/after-service`}><span className={styles['cor-purple']}>{words?.support_benefit_notes_link}</span></a> */}
        {/* 您可以通过纸质及电子发票，享受相关保修服务，详细信息可以查询PICO产品 */} 
        {/* 保修政策 */}
      </p>
      <p>
        {words?.support_benefit_notes_content2}
        {/* 若您产品支持电子保修凭证，且您同意以电子保修凭证记录的预估保修截止日期作为保修期，可将电子保修凭证作为保修凭证使用。 */}
      </p>
      <p>
        {/* {words?.support_benefit_notes_content3} */}
        {/* 您可以通过登录PICO消费者服务官网，点击保修及权益查询 ，输入设备序列号以及验证码，查看电子保修凭证。 */}
      </p>
      <p>
        {/* {words?.support_benefit_notes_content4} */}
        {/* 若您对查询结果存疑，可以提供相关购买凭证（发票）进行鉴定 */}
      </p>
    </div>
  )
}
export default Notes